module.exports = __webpack_public_path__ + "img/welcome.86d3f9ce.png";